import React, { useEffect, useCallback, useRef, useState, useMemo } from "react";

import UserAuthSelected from "./UserAuth_Selected";
import axios from 'util/axios';

import Pagination, { SetPager } from "util/component/Pagination/v2";

import { BORDER_COLOR } from "../Functions";

import SearchableSelectMulti from "util/component/SearchableSelect/asyncMultiv2";

import ModalPortal from "util/component/Modal";
import { Confirm, ConfirmWithMessage, Modal } from "util/component/Modal/Modal";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import style from "../styles.scss";
import update from "immutability-helper";

const VIEW_PAGE = 15;

const SEARCHCONDITION = {
    userId: "",
    userNm: "",
    department: "",
    auth: [],
};

const UserAuthRender = (props) => {
    const { auth, deleteAuth } = props;
    return (
        <div className={"userAuth-btn-list"}>
            {auth?.map((row, i) => {
                return (
                    <button
                        key={"userAuthInner" + i}
                        style={{
                            borderColor: BORDER_COLOR[row.code],
                            color: BORDER_COLOR[row.code],
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            deleteAuth(row);
                        }}
                    >
                        {row.name}
                    </button>
                );
            })}
        </div>
    );
};

const UserAuthMain = (props, ref) => {
    const TBL_DATA_REF = useRef([]);
    const TBL_DATA_ORIGIN = useRef([]);
    const [PAGER, SetPAGER] = useState(null);
    const [UserList, SetUserList] = useState([]);

    const [SelectedUser, SetSelectedUser] = useState([]);

    const [SearchCondition, SetSearchCondition] = useState(SEARCHCONDITION);

    const userSelector = useSelector((store) => store.user);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);

    const [AuthList, SetAuthList] = useState([]);

    const [ShowModal, SetShowModal] = useState(null);

    const [ShowUserAdd, SetShowUserAdd] = useState(false);

    const [UserAdd, SetUserAdd] = useState({ userId: "", userNm: "", auth: [] });

    const { t } = useTranslation(["page"]);

    const ModalMessage = useRef(null);
    const [ModalOpen, SetModalOpen] = useState(false);

    const getUserList = async () => {
        const response = await axios.post(process.env.REACT_APP_API + "/user/retrieveUserList").then((Response) => Response?.data?.data?.result);
        TBL_DATA_ORIGIN.current = response || [];
        TBL_DATA_REF.current = [...TBL_DATA_ORIGIN.current];

        const pager = new SetPager(TBL_DATA_REF.current.length, VIEW_PAGE);
        SetPAGER({ data: pager });
        SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
    };

    useEffect(() => {
        getUserList();
        axios
            .post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                grcd: "USER",
            })
            .then((Response) => {
                SetAuthList(Response.data.data.result);
            })
            .catch((Error) => console.error(Error));
    }, []);

    useEffect(() => {
        if (!PAGER) return;

        const range = PAGER.data.getItemRange();
        let setData = [];
        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_REF.current[i]);
        }
        SetUserList(setData);
    }, [PAGER]);

    const HandleSearchCondition = (element) => {
        const name = element.target.name;
        const value = element.target.value;
        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const HandleSearchConditionAuth = (selected) => {
        selected = selected?.sort((a, b) => parseInt(a.value) - parseInt(b.value));
        SetSearchCondition((OLD) => ({ ...OLD, auth: selected }));
    };

    const inputDelayRef = useRef(null);

    useEffect(() => {
        clearTimeout(inputDelayRef.current);
        inputDelayRef.current = setTimeout(() => {
            const { userId, userNm, department, auth } = SearchCondition;
            TBL_DATA_REF.current = TBL_DATA_ORIGIN.current;
            if (userId || userNm || department || auth.length > 0) {
                if (userId) {
                    if (userId.length >= 2) {
                        TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                            const regex = new RegExp(userId, "gi");
                            return f.userId?.match(regex);
                        });
                    }
                }
                if (userNm) {
                    if (userNm.length >= 2) {
                        TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                            const regex = new RegExp(userNm, "gi");
                            return f.userNm?.match(regex);
                        });
                    }
                }
                if (department) {
                    if (department.length >= 2) {
                        TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                            const regex = new RegExp(department, "gi");
                            return f.department.match(regex);
                        });
                    }
                }
                if (auth.length > 0) {
                    const authArr = auth.map((f) => f.value.toString());
                    TBL_DATA_REF.current = TBL_DATA_REF.current.filter((f) => {
                        const auths = JSON.parse(f?.codes)?.map((a) => a.code.toString());
                        
                        // return auths.find(a => authArr.includes(a.code.toString()))
                        return auths?.filter(x => authArr.includes(x)).length > 0;
                    });
                }
            }
            const pager = new SetPager(TBL_DATA_REF.current.length, VIEW_PAGE);
            SetPAGER({ data: pager });
        }, 500);
    }, [SearchCondition]);

    const deleteAuthOneConfirm = async (userId, auth, msg) => {
        const postData = {
            data: [
                {
                    userId,
                    authCode: auth.code,
                },
            ],
            msg: msg,
            message: msg,
            userId: userSelector.userId,
            action: "delete",
        };
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/user/authChange", postData);
            const result = response.data.data.result;
            if (result === "ERR901") {
                SetModalMsg(<p style={{ textAlign: "center" }}>{t(result.toString())}</p>);
                SetModalOpen(true);
            }


        } catch (e) {
            console.error(e);
        } finally {
            getUserList();
        }
    };


    const disableUserConfirm = async (user,flag,msg) => {

        const disableYn = flag === "Y" ? "N" : "Y" ;
        const postData = {
            userId : user,
            disableYn : disableYn,
            msg: msg,
            message: msg
        };
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/user/modifyUserDisableYn", postData);
            const result = response.data.data.result;

        } catch (e) {
            console.error(e);
        } finally {
            getUserList();
        }
    };

    const deleteAuthOne = (userId, auth) => {
        SetShowModal(<ConfirmWithMessage onClose={() => SetShowModal(null)} message="Delete Authority" onConfirm={(msg) => deleteAuthOneConfirm(userId, auth, msg)} />);
    };

    const disableUser = (userId,flag) => {
        SetShowModal(<ConfirmWithMessage onClose={() => SetShowModal(null)} message={flag === "Y" ? "Enabled Message" : "Disabled Message" } onConfirm={(msg) => disableUserConfirm(userId, flag, msg)} />);
    };

    const SelectUser = useCallback(
        (user) => {
            console.log(user);
            if (!SelectedUser.find((f) => f.userId === user.userId )) {

                if(user.disableYn === "N"){
                    SetSelectedUser((OLD) => [...OLD, user]);
                }

            }
        },
        [SelectedUser]
    );

    const RemoveSelectedUser = (user) => {
        SetSelectedUser((OLD) => {
            const NewData = [...OLD];

            const findIdx = NewData.findIndex((f) => f.userId === user.userId);

            NewData.splice(findIdx, 1);
            return NewData;
        });
    };



    const renderUserList = useMemo(() => {
        const render = UserList?.map((rowData, index) => {
            const parseAuth = JSON.parse(rowData.codes);
            parseAuth.sort((a,b)=>a.order.localeCompare(b.order));

            return (
                <tr key={`userAuthMainList${index}`} onClick={() => SelectUser(rowData)} style={ {background:`${rowData.disableYn === "Y" ? "#80808069" :""}` }}>
                    <td title={rowData.userNm}>{rowData.userId}</td>
                    <td title={rowData.userNm}>{rowData.userNm}</td>
                    {/* <td>{rowData.department}</td> */}
                    <td>
                        <UserAuthRender auth={parseAuth} deleteAuth={(auth) => deleteAuthOne(rowData.userId, auth)} />
                    </td>
                    <td className={"ellipsis"} style={{ fontSize: "0.8rem" }}>
                        {rowData.loginDt}
                    </td>
                    <td style={{textAlign:"center"}}>
                        <button
                            style={{width: "max-content"}}
                            className={`tBtn ${rowData.disableYn === "N" ? style.content : style.sub }`}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                disableUser(rowData.userId,rowData.disableYn);
                            }}
                        >

                            {rowData.disableYn === "N" ? t("active") : t("inactive")}

                        </button>
                    </td>
                </tr>
            );
        });

        return render;
    }, [SelectUser, UserList]);

    const userAuthChangeConfirm = async (action, auth, msg) => {
        const data = [];
        SelectedUser.forEach((i) => {
            auth.forEach((j) => {
                data.push({ userId: i.userId, authCode: j.code });
            });
        });
        const postData = {
            data: data,
            msg: msg,
            message: msg,
            userId: userSelector.userId,
            action: action,
        };
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/user/authChange", postData);
            const result = response.data.data.result;
            if (result === "ERR901") {
                SetModalMsg(<p style={{ textAlign: "center" }}>{t(result.toString())}</p>);
                SetModalOpen(true);
            }
            // const result = response.data.data.result;
        } catch (e) {
            console.error(e);
        } finally {
            //window.location.reload();
            // SetSelectedUser([]);
            getUserList();
        }
    };

    const userAuthChange = (action, auth) => {
        SetShowModal(<ConfirmWithMessage onClose={() => SetShowModal(null)} message={`${action} Authority`} onConfirm={(msg) => userAuthChangeConfirm(action.toLowerCase(), auth, msg)} />);
    };

    const UserAddValid = () => {
        const { userId, userNm, auth } = UserAdd;
        const textarea = document.getElementById("textareaUserAdd");
        
        if (userId && userNm && auth.length > 0 && textarea.value) return true;
        else {
            SetUserAdd((OLD) => ({ ...OLD, invalid: true }));
            return false;
        }
    };

    const UserAddAction = async () => {
        let { userId, userNm, auth } = UserAdd;
        auth = auth.map((e) => ({ authCode: e.code, userId }));
        const external = auth.some((data) => data.authCode === "20")
        const botExternal = auth.some((data) => data.authCode !== "20")
        if (external && botExternal) {
            SetModalMsg(<p style={{ textAlign: "center" }}>{t("ERR902")}</p>);
            SetModalOpen(true);
            return;
        }

        const ownerId = userSelector.userId;
        const textarea = document.getElementById("textareaUserAdd");
        const postData = { userId, userNm, ownerId, auth, message: textarea.value };
        const response = await axios.post(process.env.REACT_APP_API + "/user/createUser", postData);

        if (response.data?.data?.result === "ERR903") {
            SetModalMsg(<p style={{ textAlign: "center" }}>{t("ERR903")}</p>);
            SetModalOpen(true);
        } else {
            SetShowUserAdd(false);
            getUserList();
        }
    };

    const HandleAddUserShow = () => {
        SetUserAdd({ userId: "", userNm: "", auth: [] });
        SetShowUserAdd(!ShowUserAdd);
    };
    const HandleModalOpen = () => {
        SetModalOpen(!ModalOpen);
    };

    return (
        <div>
            <div style={{ marginBottom: "10px" }}>
                <button className={"bpl-btn success"} onClick={HandleAddUserShow}>
                    + Add User
                </button>
            </div>
            <div className={"wrapper"}>
                <div className={"userAuthMainTable"}>
                    <table className={"bpl-table-default fixed has-pagination userAuthMainTable-table"}>
                        <colgroup>
                            <col width="150px" />
                            <col width="200px" />
                            {/* <col width="120px" /> */}
                            <col />
                            <col width="150px" />
                            <col width="85px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>User ID</th>
                                <th>User Name</th>
                                {/* <th>Department</th> */}
                                <th>Authorization</th>
                                <th>Last Logedin</th>
                                <th>Status</th>
                            </tr>
                            <tr>
                                <td>
                                    <input type="text" className={"bpl-input-default"} name={"userId"} value={SearchCondition.userId} placeholder={"ID"} onChange={HandleSearchCondition} />
                                </td>
                                <td>
                                    <input type="text" className={"bpl-input-default"} name={"userNm"} placeholder={"Name"} value={SearchCondition.userNm} onChange={HandleSearchCondition} />
                                </td>
                                {/* <td>
                                    <input
                                        type="text"
                                        className={"bpl-input-default"}
                                        name={"department"}
                                        placeholder={"Department"}
                                        value={SearchCondition.department}
                                        onChange={HandleSearchCondition}
                                    />
                                </td> */}
                                <td>
                                    <SearchableSelectMulti value={SearchCondition.auth} placeholder="Authority" onChange={HandleSearchConditionAuth} options={AuthList} v2={true} />
                                </td>
                                <td className={"text-center"}>
                                    <button style={{ fontSize: "0.8rem" }} className={"bpl-btn danger small filled"} onClick={() => SetSearchCondition(SEARCHCONDITION)}>
                                        Clear
                                    </button>
                                </td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>{renderUserList}</tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="4">
                                    <Pagination data={PAGER?.data} set={(data) => SetPAGER({ data: data, refresh: new Date() })} />
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <UserAuthSelected selecteduser={SelectedUser} removeSelectedUser={RemoveSelectedUser} authList={AuthList} onChange={userAuthChange} />
                {ShowModal && <ModalPortal>{ShowModal}</ModalPortal>}
                {ModalOpen && (
                    <ModalPortal>
                        <Modal onClose={HandleModalOpen}>{ModalMsg}</Modal>
                    </ModalPortal>
                )}
                {ShowUserAdd && (
                    <ModalPortal>
                        <Confirm autoComplete={false} overflow={"overflow"} onClose={HandleAddUserShow} valid={UserAddValid} onConfirm={UserAddAction}>
                            <div style={{ width: "50vw", height: "300px" }}>
                                <div style={{ marginBottom: "5px" }}>
                                    <p
                                        style={{
                                            textAlign: "left",
                                            marginBottom: "3px",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        User Id:
                                    </p>
                                    <input
                                        type={"text"}
                                        value={UserAdd.userId}
                                        onChange={(e) => {
                                            SetUserAdd((OLD) => ({
                                                ...OLD,
                                                userId: e.target.value,
                                                invalid: false,
                                            }));
                                        }}
                                        placeholder="Input User ID"
                                        className={"bpl-input-default single border"}
                                    />
                                </div>
                                <div style={{ marginBottom: "5px" }}>
                                    <p
                                        style={{
                                            textAlign: "left",
                                            marginBottom: "3px",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        User Name:
                                    </p>
                                    <input
                                        type={"text"}
                                        value={UserAdd.userNm}
                                        onChange={(e) => {
                                            SetUserAdd((OLD) => ({
                                                ...OLD,
                                                userNm: e.target.value,
                                                invalid: false,
                                            }));
                                        }}
                                        placeholder="Input User Name"
                                        className={"bpl-input-default single border"}
                                    />
                                </div>
                                <div style={{ marginBottom: "5px" }}>
                                    <p
                                        style={{
                                            textAlign: "left",
                                            marginBottom: "3px",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        Authority:
                                    </p>
                                    <SearchableSelectMulti
                                        placeholder="Choose Authority"
                                        value={UserAdd.auth}
                                        onChange={(selected) => {
                                            SetUserAdd((OLD) => ({
                                                ...OLD,
                                                auth: selected,
                                                invalid: false,
                                            }));
                                        }}
                                        options={AuthList}
                                        v2={true}
                                    />
                                </div>
                                <div style={{ marginBottom: "5px" }}>
                                    <p
                                        style={{
                                            textAlign: "left",
                                            marginBottom: "3px",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        Memo:
                                    </p>
                                    <textarea style={{ marginTop: "10px", border: "1px solid #999", outline: "none" }} id="textareaUserAdd"></textarea>
                                </div>
                                {UserAdd.invalid && <p style={{ margin: 0, color: "red" }}>All fields is required</p>}
                            </div>
                        </Confirm>
                    </ModalPortal>
                )}
            </div>
        </div>
    );
};

export default UserAuthMain;
